import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import AuthView from 'components/AuthView';
import {
    updateDocumentTitle,
} from 'actions';
import './invoiceWinnerNotifier.scss';
import ImportFile from './ImportFile';
import InvoiceNotifier from './InvoiceNotifier';

const InvoiceWinnerNotifier = () => {
    const [showActionPanel, setShowActionPanel] = useState(false);
    const dispatch = useDispatch();
    const i18n = useSelector(state => state.i18n);
    useEffect(() => { }, [i18n]);
    useEffect(() => {
        dispatch(updateDocumentTitle('invoice_winner_notifier.document_title'));
        // eslint-disable-next-line
    }, []);

    const toggleActionPanel = () => {
        setShowActionPanel(!showActionPanel);
    }

    return (
        <AuthView className="invoice-winner-notifier">
            <InvoiceNotifier onClick={ toggleActionPanel } />
            {
                showActionPanel && <ImportFile onCancel={ toggleActionPanel } />
            }
        </AuthView>
    )
}

export default InvoiceWinnerNotifier;
